import VerifyPageComponent from '@/modules/verify/verify-page'

const VerifyPage = () => {
  return <VerifyPageComponent />
}

export default VerifyPage